import { Schema } from 'rsuite';
import { set, reduce } from 'lodash/fp';
import {
  getValidatorForFieldType,
  createConditionalRequiredRule
} from '../Form/settings';

const { DateType, StringType, NumberType } = Schema.Types;

export const DefaultValues = {
  name: '',
  age: null,
  rel: '',
  gender: '',
  race: '',
  note: ''
};

export const showFieldsPerSettings = settings => ({
  race: settings.guestAdditionalRaceOther === '1',
  gender: settings.guestAdditionalGenderOther === '1'
});

export const requiredFieldsPerSettings = settings => ({
  age: settings.guestOtherAgeReq === '1',
  race: settings.guestAdditionalRaceReq === '1',
  gender: settings.guestAdditionalRaceReq === '1',
  rel: settings.guestOtherRelReq === '1'
});

export const createModelSchema = ({ formFields, requiredFields }) => {
  const mainFieldsSchema = {
    name: StringType().isRequired(),
    age: createConditionalRequiredRule(DateType(), requiredFields.age),
    rel: createConditionalRequiredRule(StringType(), requiredFields.rel),
    gender: createConditionalRequiredRule(NumberType(), requiredFields.gender),
    race: createConditionalRequiredRule(NumberType(), requiredFields.race),
    note: StringType()
  };

  const customFieldsSchema = reduce(
    (allFields, { name, fieldType, isRequired }) =>
      name.substring(0, 3) === 'cf_'
        ? set(
            name,
            createConditionalRequiredRule(
              getValidatorForFieldType(fieldType),
              isRequired
            ),
            allFields
          )
        : allFields,
    {},
    formFields
  );

  return Schema.Model({ ...mainFieldsSchema, ...customFieldsSchema });
};
